import React from "react";
import { useLocation } from "react-router-dom";
import { BreadcrumbProvider } from "./context/BreadcrumbContext";
import HomeLink from "./components/HomeLink";
import BreadcrumbItem from "./components/BreadcrumbItem";

const Breadcrumb: React.FC = () => {
  const location = useLocation();
  const pathnames = location.pathname.split("/").filter((x) => x);

  return (
    <BreadcrumbProvider>
      <nav className="border-b border-neutral-200 bg-neutral-50">
        <div className="mx-auto max-w-7xl px-4 py-3 sm:px-6 lg:px-8">
          <ol className="flex items-center space-x-2 text-sm">
            <HomeLink />
            {pathnames.map((pathname, index) => {
              const routeTo = `/${pathnames.slice(0, index + 1).join("/")}`;
              const isLast = index === pathnames.length - 1;

              return (
                <BreadcrumbItem
                  key={pathname}
                  pathname={pathname}
                  routeTo={routeTo}
                  isLast={isLast}
                  index={index}
                />
              );
            })}
          </ol>
        </div>
      </nav>
    </BreadcrumbProvider>
  );
};

export default Breadcrumb;
